var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Emisiowa Stronka")]),_c('v-img',{staticClass:"jumping",attrs:{"src":"/static/emisia_nobg.png","contain":"","height":"500"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }